import { PlatformType } from 'osn-shared';
import {
  BackgroundImageViewModel,
  PlatformLocalizedImagesViewModel,
} from '../../../shared/components/image-upload-control/image-upload-view-model';
import { LocalizedFormData } from '../../common/localized-form-data';
import { ViewModelCommon } from '../view-model-common/view-model-common';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';

export enum PartnerVoucherViewModelType {
  VoucherCode = 'Voucher code',
  CardNumber = 'Card number',
}

export interface RedeemPartnerVoucherTrayFormViewModel extends ViewModelCommon {
  id?: string;
  name: string;
  type: TrayFormViewModelType.RedeemPartnerVoucherTray;

  campaignCode: string;

  mainCtaText: LocalizedFormData<string>;
  voucherBoxText: LocalizedFormData<string>;
  instructionText: LocalizedFormData<string>;
  buttonText: LocalizedFormData<string>;
  backgroundImages: PlatformLocalizedImagesViewModel<PlatformType.Web | PlatformType.Mobile>;

  voucherType: PartnerVoucherViewModelType;

  partnerLogo: BackgroundImageViewModel;
}
